export class String {
  static Empty = "";

  static isNullOrWhiteSpace(value: string | null | undefined) {
    return !value || value.trim().length < 1;
  }

  static truncate(original: string | undefined, limit: number) {
    if (!original) {
      return original;
    } else {
      return original.length > limit
        ? `${original.substring(0, Math.min(original.length, limit)).trim()}...`
        : original;
    }
  }
}
